import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import TabletCheckup from '@/components/TabletCheckup';

/* Check-Up am Studio-Tablet als eigene Vollbild-Seite (28.10.2026): /checkup/<token> — derselbe Geräte-Link-Token wie
   /trainer/<token> (Haken `checkup_tablet`), aber NUR der Check-Up, ohne Kalender, Anwesenheit und Leads.
   „Zum Home-Bildschirm“ (Safari › Teilen) macht daraus eine App ohne Browserleiste. Bewusst KEIN Manifest: iOS nähme sonst
   dessen start_url statt des Links mit Token (wie bei der Anwesenheits-Tafel). */
function useVollbildApp() {
  useEffect(() => {
    const gesetzt = [];
    const meta = (name, content) => {
      const m = document.createElement('meta'); m.name = name; m.content = content;
      document.head.appendChild(m); gesetzt.push(m);
    };
    meta('apple-mobile-web-app-capable', 'yes');
    meta('mobile-web-app-capable', 'yes');
    meta('apple-mobile-web-app-status-bar-style', 'default');
    meta('apple-mobile-web-app-title', 'P1 Check-Up');
    // 28.10.2026 Betreiber: Symbol auf dem Home-Bildschirm weiß mit schwarzem P1 (quadratisch, sonst füllt iOS schwarz auf)
    const icon = document.createElement('link'); icon.rel = 'apple-touch-icon'; icon.sizes = '180x180'; icon.href = '/media/checkup-icon-180.png';
    document.head.appendChild(icon); gesetzt.push(icon);
    const vp = document.querySelector('meta[name="viewport"]');
    const alt = vp?.content;
    if (vp) vp.content = 'width=device-width, initial-scale=1, viewport-fit=cover';
    const titel = document.title; document.title = 'P1 Check-Up';
    return () => { gesetzt.forEach((e) => e.remove()); if (vp && alt) vp.content = alt; document.title = titel; };
  }, []);
}

export default function CheckupTabletPage() {
  const { token } = useParams();
  useVollbildApp();
  return (
    <div className="min-h-screen bg-background text-foreground"
      style={{ paddingTop: 'env(safe-area-inset-top)', paddingBottom: 'env(safe-area-inset-bottom)', paddingLeft: 'env(safe-area-inset-left)', paddingRight: 'env(safe-area-inset-right)' }}
      data-testid="checkup-tablet-seite">
      <header className="flex items-center gap-3 px-4 py-3 border-b border-border">
        <img src="/media/p1-logo.png" alt="P1" className="h-8 object-contain" />
        <p className="text-lg font-bold">Check-Up</p>
      </header>
      <TabletCheckup token={token} />
    </div>
  );
}
